export default [
  'SourceSansProRegular',
  'SourceSansProExtraLight',
  'SourceSansProLight',
  'SourceSansProSemiBold',
  'SourceSansProBold',
] as string[];
